// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"231":"142f6e09","745":"575cdc4a"}[chunkId] + ".chunk.js";
};